import { Send, Check } from "../../../shared/icons";

// Ações de status aplicáveis a vários plantões de uma vez. A elegibilidade olha o
// `estado` persistido, não o `status` exibido: um plantão em atraso ainda aguardando NF
// mostra status "em_atraso", mas aceita "Marcar NF emitida". Plantões agendados (data de
// trabalho no futuro) ficam de fora: o lote é para o dia de emitir a nota e de receber.
const isWorked = (shift) => shift.schedule_status !== "scheduled";

export const BULK_STATUS_ACTIONS = [
  {
    acao: "marcar_nf_emitida",
    label: "Marcar NF emitida",
    icon: Send,
    variant: "outline",
    successTitle: (n) => `${n} plantão(ões) com NF emitida`,
    isEligible: (shift) => isWorked(shift) && shift.estado === "aguardando_nf",
  },
  {
    acao: "marcar_recebido",
    label: "Marcar como recebido",
    icon: Check,
    variant: "solid",
    successTitle: (n) => `${n} plantão(ões) marcado(s) como recebido(s)`,
    isEligible: (shift) => isWorked(shift) && shift.estado !== "recebido",
  },
];
